import clsx from "clsx";

export default function CirclePreview({
  imageURL,
  name,
  previewOf,
  className,
  isHighlighted = false,
}: {
  imageURL: string;
  name: string;
  previewOf: string;
  className?: string;
  isHighlighted?: boolean;
}) {
  return (
    <div
      title={`${name} ${previewOf} ${isHighlighted ? " | User interaction completed" : ""}`}
      className={clsx(
        "flex h-12 w-12 cursor-pointer items-center justify-center overflow-hidden rounded-full",
        className || "",
        isHighlighted
          ? "border-[3px] border-lime-500 hover:border-lime-400"
          : "border-[2px] border-neutral-300 hover:border-white",
      )}
    >
      <img src={imageURL} alt={`${name} ${previewOf}`} className="min-h-full min-w-full" />
    </div>
  );
}
